const FileIcon = () => {
    return (
        <svg
            id="Group_8233"
            data-name="Group 8233"
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="26"
            viewBox="0 0 25 31"
        >
            <g id="Group_8231" data-name="Group 8231">
                <path
                    id="Path_3503"
                    data-name="Path 3503"
                    d="M4.376.5V2.319A2.237,2.237,0,0,1,2.162,4.576H.5M4.376.5,22.1.535A2.237,2.237,0,0,1,24.31,2.792v25.26A2.235,2.235,0,0,1,22.1,30.308l-19.38-.035A2.237,2.237,0,0,1,.5,28.016V4.576M4.376.5.5,4.576"
                    transform="translate(0.095 0.096)"
                    fill="none"
                    stroke="#0c3b8d"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <path
                    id="Path_3504"
                    data-name="Path 3504"
                    d="M4.5,8.1a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1a.6.6,0,0,1-.6-.6m0,4.769a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1a.6.6,0,0,1-.6-.6m0,4.769a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1a.6.6,0,0,1-.6-.6m0,4.769a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1a.6.6,0,0,1-.6-.6"
                    transform="translate(0.857 1.442)"
                    fill="#d6d6d6"
                />
                <path
                    id="Path_3505"
                    data-name="Path 3505"
                    d="M4.5,8.1a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1A.6.6,0,0,1,4.5,8.1Zm0,4.769a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1A.6.6,0,0,1,4.5,12.865Zm0,4.769a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1A.6.6,0,0,1,4.5,17.635Zm0,4.769a.6.6,0,0,1,.6-.6h13.1a.6.6,0,0,1,0,1.192H5.1A.6.6,0,0,1,4.5,22.4Z"
                    transform="translate(0.857 1.442)"
                    fill="none"
                    stroke="#d6d6d6"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default FileIcon;
